import logo1 from "../../image/logotype/logo_corn.svg";
import logo2 from "../../image/logotype/MAS Seeds.svg";
// import logo3 from "../../image/logotype/Agroseme-logo.jpg";
import goodsPage from "../../image/goods.image/corn/qbyHGQcOhx.png";
import goodsPage1 from "../../image/goods.image/corn/vdNT2eOvoT.jpeg";
// import goodsPage2 from "../../image/goods.image/corn/agrosemesumo3.jpg";
import Button from "../../assets/Button/ButtonBuy/ButtonBuy"
import { Link } from "react-router-dom";


export const items = [
    {
        title: "Гібрид кукурудзи НК Кобальт (NK Kobalt)",
        priceFirst: 'від 2 500 грн',
        unitFirst: "1 п.о.",
        producer: "Syngenta",
        InStock: false,
        imgLogo: <img className="itemCard__image-logo" src={logo1} alt="logo" />,
        imgUrl: <img className="itemCard__image" src={goodsPage} alt="logo" />,
        isNew: false,
        link: <Link to="order"><Button /></Link>,
        inside: "kobalt",
        id: "1"
    },
    {
        title: "Гібрид кукурудзи СИ Аріосо (SY Arioso)",
        priceFirst: 'від 2 500 грн',
        unitFirst: "1 п.о.",
        producer: "Syngenta",
        InStock: false,
        imgLogo: <img className="itemCard__image-logo" src={logo1} alt="logo" />,
        imgUrl: <img className="itemCard__image" src={goodsPage} alt="logo" />,
        isNew: false,
        link: <Link to="order"><Button /></Link>,
        inside: "arioso",
        id: "2"
    },
    {
        title: "Гібрид кукурудзи НК Термо (NK Termo)",
        priceFirst: 'від 2 500 грн',
        unitFirst: "1 п.о.",
        producer: "Syngenta",
        InStock: false,
        imgLogo: <img className="itemCard__image-logo" src={logo1} alt="logo" />,
        imgUrl: <img className="itemCard__image" src={goodsPage} alt="logo" />,
        isNew: false,
        link: <Link to="order"><Button /></Link>,
        inside: "termo",
        id: "3"
    },
    {
        title: "Гібрид кукурудзи СИ Теліас (SY Telias)",
        priceFirst: 'від 2 500 грн',
        unitFirst: "1 п.о.",
        producer: "Syngenta",
        InStock: false,
        imgLogo: <img className="itemCard__image-logo" src={logo1} alt="logo" />,
        imgUrl: <img className="itemCard__image" src={goodsPage} alt="logo" />,
        isNew: false,
        link: <Link to="order"><Button /></Link>,
        inside: "telias",
        id: "4"
    },
    {
        title: "Гібрид кукурудзи МАС 24.Ц (MAS 24.C)",
        priceFirst: 'від 2 500 грн',
        unitFirst: "1 п.о.",
        producer: "MAS Seeds",
        InStock: false,
        imgLogo: <img className="itemCard__image-logo" src={logo2} alt="logo" />,
        imgUrl: <img className="itemCard__image" src={goodsPage1} alt="logo" />,
        isNew: false,
        link: <Link to="order"><Button /></Link>,
        inside: "mas24",
        id: "5"
    },
    {
        title: " Гібрид кукурудзи МАС 30.М (MAS 30.M)",
        priceFirst: 'від 2 500 грн',
        unitFirst: "1 п.о.",
        producer: "MAS Seeds",
        InStock: false,
        imgLogo: <img className="itemCard__image-logo" src={logo2} alt="logo" />,
        imgUrl: <img className="itemCard__image" src={goodsPage1} alt="logo" />,
        isNew: false,
        link: <Link to="order"><Button /></Link>,
        inside: "mas30",
        id: "6"
    }
    // {
    //     title: "Насіння соняшнику AGROSEME КОРАЛ",
    //     priceSecond: 'від 4 300 грн',
    //     priceThird: 'від 5 600 грн',
    //     priceFourth: 'від 6 000 грн',
    //     unitSecond: "стандарт",
    //     unitThird: "екстра",
    //     unitFourth: "екстра+",
    //     producer: "AGROSEME",
    //     InStock: true,
    //     imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    //     imgUrl: <img className="itemCard__image" src={goodsPage2} alt="goodsPage" />,
    //     isNew: true,
    //     link: <Link to="order"><Button /></Link>,
    //     inside: "agroseme-corall",
    //     id: "7"
    // },
    // {
    //     title: "Насіння соняшнику AGROSEME АС ВІСЕРІНА",
    //     priceSecond: 'від 4 300 грн',
    //     priceThird: 'від 5 600 грн',
    //     priceFourth: 'від 6 000 грн',
    //     unitSecond: "стандарт",
    //     unitThird: "екстра",
    //     unitFourth: "екстра+",
    //     producer: "AGROSEME",
    //     InStock: true,
    //     imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    //     imgUrl: <img className="itemCard__image" src={goodsPage2} alt="goodsPage" />,
    //     isNew: true,
    //     link: <Link to="order"><Button /></Link>,
    //     inside: "agroseme-as-vissirina",
    //     id: "8"
    // },
    // {
    //     title: "Насіння соняшнику AGROSEME НС МОРОЗ/БАЛТРАП",
    //     priceSecond: 'від 4 300 грн',
    //     priceThird: 'від 5 600 грн',
    //     priceFourth: 'від 6 000 грн',
    //     unitSecond: "стандарт",
    //     unitThird: "екстра",
    //     unitFourth: "екстра+",
    //     producer: "AGROSEME",
    //     InStock: true,
    //     imgLogo: <img className="itemPartner__image-logo" src={logo3} alt="logo" />,
    //     imgUrl: <img className="itemCard__image" src={goodsPage2} alt="goodsPage" />,
    //     isNew: true,
    //     link: <Link to="order"><Button /></Link>,
    //     inside: "agroseme-ns-moroz-balttrap",
    //     id: "9"
    // }
];
